function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN'
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 1280px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
    });
    this.mainDetailsToggle.querySelectorAll('.menu-opening').forEach(el => {
      el.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class GaiaHeader extends HTMLElement {
  constructor() {
    super();

    // Scroll logic now applies to the entire header group

    const headerGroup = document.querySelector('.header-content');
    if (!headerGroup) return;

    // Track previousScroll outside the handler
    let previousScroll = window.scrollY;
    // Add a flag to suppress scroll handler after reveal
    this._suppressScrollHandler = false;

    window.addEventListener('scroll', () => {
      // If suppress flag is set, skip this scroll event
      if (this._suppressScrollHandler) return;

      let headerRect = headerGroup.getBoundingClientRect();
      let headerPos = 0;
      // Get threshold from CSS variable --header-height
      const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue(
        '--header-height'
      );
      const headerHeight = parseInt(headerHeightVar) || 0;

      if (window.scrollY < headerHeight) {
        // At top of page or within threshold
        headerGroup.classList.add('header--top');
        headerGroup.classList.remove('header--hidden');
      } else if (window.scrollY > previousScroll) {
        // Scrolling down past threshold
        headerPos = 0 - headerRect.height;
        headerGroup.classList.add('header--hidden');
        headerGroup.classList.remove('header--top');
      } else if (window.scrollY < previousScroll) {
        // Scrolling up, header visible (not at top)
        headerGroup.classList.remove('header--hidden');
        headerGroup.classList.remove('header--top');
      }
      headerGroup.style.top = `${headerPos}px`;
      previousScroll = window.scrollY;
    });

    // Keep click logic for gaia-header for --header-bottom-position
    this.addEventListener('click', () => {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.getBoundingClientRect().bottom)}px`
      );
    });
  }
  // Show header group, regardless of sticky
  reveal() {
    const headerGroup = document.querySelector('.header-content');
    // Suppress scroll handler for a short time after reveal
    // Fix for mouse scroll/windows combo that caused header to hide when opening dropdowns
    this._suppressScrollHandler = true;
    setTimeout(() => {
      this._suppressScrollHandler = false;
    }, 150);
    if (headerGroup) {
      headerGroup.classList.remove('header--hidden', 'header--scrolled-up');
      headerGroup.style.top = '0px';
    }
  }
}

customElements.define('gaia-header', GaiaHeader);

// Remove .transparent-header from gaia-header if no hero section is present (for pages without transparent-header.js)
document.addEventListener('DOMContentLoaded', function () {
  console.log('loaded');
  var heroSection = document.querySelector('.banner.top-section.transparent-header');
  var gaiaHeader = document.querySelector('gaia-header');
  if (!heroSection && gaiaHeader) {
    gaiaHeader.classList.remove('transparent-header');
  }
});

class GaiaDropdown extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('summary + *');

    this.details.classList.add('closed');

    if (this.content.getAttribute('tabindex') === null)
      // this.content.setAttribute("tabindex", "0");

      this.summary.addEventListener('click', e => {
        // If this is the header dropdown, make sure header shows
        const gaiaHeader = this.closest('gaia-header');
        if (gaiaHeader && typeof gaiaHeader.reveal === 'function') {
          gaiaHeader.reveal();
        }
        this.click(e);
      });

    this.querySelectorAll('.child-menu-close').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        this.close();
      });
    });

    this.clickOffListener = this.clickOff.bind(this);

    // Watch for switches between desktop/mobile
    this.previousState = window.matchMedia('(min-width: 1233px)').matches ? 'desktop' : 'mobile';
    window.addEventListener('resize', this.handleResize.bind(this));

    //Reinit to fix filter issue of dropdowns not working after filter applying
    this.addEventListener('dropdown:reinit', () => {
      this.initDropdown(true);
    });

    if (this.details) {
      this.details.addEventListener('toggle', () => {
        this.updateBodyOverflow();
      });
    }
  }

  updateBodyOverflow() {
    // Only apply if this dropdown is inside a gaia-header
    const gaiaHeader = this.closest('gaia-header');
    if (!gaiaHeader) return;
    // Check if any dropdown in this header is open
    const anyOpen = gaiaHeader.querySelectorAll('gaia-dropdown details[open]').length > 0;
    if (anyOpen) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }

  initDropdown(isReinit = false) {
    // Remove previous listeners if re-initializing
    if (isReinit && this.summary) {
      this.summary.removeEventListener('click', this._summaryClickHandler);
      this.summary.removeEventListener('keydown', this._summaryKeydownHandler);
    }

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('summary + *');

    if (!this.details || !this.summary || !this.content) return;

    this.details.classList.add('closed');

    if (this.content.getAttribute('tabindex') === null) this.content.setAttribute('tabindex', '0');

    // Store handler so it can be removed on reinit
    this._summaryClickHandler = e => this.click(e);
    this._summaryKeydownHandler = e => {
      if (e.key === 'Enter' || e.key === ' ') {
        if (this.details.open) {
          e.preventDefault();
          this.close();
        }
      }
    };
    this.summary.addEventListener('click', this._summaryClickHandler);
    this.summary.addEventListener('keydown', this._summaryKeydownHandler);

    this.clickOffListener = this.clickOff.bind(this);

    // Watch for switches between desktop/mobile
    this.previousState = window.matchMedia('(min-width: 1233px)').matches ? 'desktop' : 'mobile';
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  // Resize checker to see if gaia-dropdowns should be forced open (desktop) or not
  handleResize() {
    const isDesktop = window.matchMedia('(min-width: 1233px)').matches;
    const isMobile = !isDesktop;
    const currentState = isDesktop ? 'desktop' : 'mobile';

    // Only trigger if changed between desktop/mobile
    if (currentState !== this.previousState) {
      if (isMobile) {
        // console.log("Switching to mobile: collapsing all dropdowns");
        // Collapse all dropdowns when switching to mobile
        document.querySelectorAll('gaia-dropdown').forEach(dropdown => {
          if (dropdown.details) {
            dropdown.close();
          }
        });
      }
      this.previousState = currentState;
    }
  }
  clickOff(e) {
    if (!this.details.open) return;
    // If click is inside the dropdown, do nothing
    if (this.contains(e.target)) return;
    // If has-modal, allow clicks inside the modal content (predictive search)
    if (this.classList.contains('has-modal')) {
      // Find the predictive search element inside the dropdown
      const predictiveSearch = this.querySelector(
        ".predictive-search, [data-predictive-search], form[role='search']"
      );
      if (predictiveSearch && predictiveSearch.contains(e.target)) return;
    }
    this.close();
  }

  click(e) {
    e.preventDefault();

    if (
      this.details.open ||
      this.details.classList.contains('opening') ||
      this.details.classList.contains('open')
    ) {
      this.close();
    } else {
      this.open();
    }
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector('details');
    if (detailsElement) {
      const summaryElement = detailsElement.querySelector('summary');
      // Get the visible text from the summary (excluding SVGs/icons)
      let summaryText = '';
      summaryElement.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          summaryText += node.textContent.trim();
        }
      });
      if (!summaryText) {
        // Fallback: get all textContent, then trim
        summaryText = summaryElement.textContent.trim();
      }
      if (detailsElement.hasAttribute('open')) {
        summaryElement.setAttribute('aria-label', `Close ${summaryText} accordion`);
        summaryElement.setAttribute('aria-expanded', 'true');
      } else {
        summaryElement.setAttribute('aria-label', `Open ${summaryText} accordion`);
        summaryElement.setAttribute('aria-expanded', 'false');
      }
      // Optionally update detailsElement's aria-label too
      detailsElement.setAttribute(
        'aria-label',
        `${detailsElement.hasAttribute('open') ? 'Close' : 'Open'} ${summaryText} accordion`
      );
    }
  }

  open() {
    this.details.classList.remove('closed');
    this.details.classList.remove('closing');
    this.details.classList.add('opening');
    this.details.setAttribute('open', true);

    if (!this.closest('details')) {
      if (this.closest('header')) {
        document.body.classList.add('overflow-hidden');
        document.body.classList.add('menu-open');
      }
    }

    // Remove delay: set focus and trap immediately
    this.details.classList.remove('opening');
    this.details.classList.add('open');
    if (this.closest('header')) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('menu-open');
    }
    if (this.classList.contains('has-modal')) {
      const predictive = this.querySelector('predictive-search');
      if (predictive) {
        trapFocus(predictive, predictive.input || predictive);
        if (predictive.input) {
          predictive.input.focus();
        }
      } else {
        trapFocus(this.details, this.details.querySelector('summary'));
      }
    }

    this.updateAriaLabel();
    // resizeAllMasonryItems(".masonry-grid");
    document.addEventListener('click', this.clickOffListener);
  }

  close() {
    this.details.classList.remove('open');
    this.details.classList.remove('opening');
    this.details.classList.add('closing');
    if (!this.closest('details')) this.removeBodyOverflow();
    // document.body.classList.remove("overflow-hidden");
    document.body.classList.remove('menu-open');
    setTimeout(() => {
      this.details.removeAttribute('open');
      this.details.classList.remove('closing');
      this.details.classList.add('closed');
      if (this.classList.contains('has-modal')) {
        removeTrapFocus(this.details.querySelector('summary'));
      }
    }, 300);
    document.removeEventListener('click', this.clickOffListener);
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
  // Fix to stop black flash when changing classes/styles of overflow hidden
  removeBodyOverflow() {
    const body = document.body;
    const afterEl = body;
    function onTransitionEnd(e) {
      if (e.propertyName === 'opacity') {
        body.classList.remove('overflow-hidden');
        document.body.classList.remove('menu-open');
        afterEl.removeEventListener('transitionend', onTransitionEnd);
      }
    }
    afterEl.addEventListener('transitionend', onTransitionEnd);
    body.classList.remove('overflow-hidden');
    document.body.classList.remove('menu-open');
  }
}

customElements.define('gaia-dropdown', GaiaDropdown);

class GaiaSelect extends GaiaDropdown {
  constructor() {
    super();

    this.selectedOption = this.querySelector('.selected-option');
    this.fieldset = this.querySelector('fieldset');
    this.options = this.querySelector('.options');
    this.summary = this.querySelector('summary');
    //Looking for  <gaia-select data-subscription-widget="true"></gaia-select>
    this.isSubscriptionWidget = this.hasAttribute('data-subscription-widget');

    this.fieldset.addEventListener('change', event => {
      // Workaround for subscription widgets, as value is needed for adding correct subscription
      if (this.isSubscriptionWidget) {
        this.selectedOption.innerText =
          this.querySelector('input:checked').getAttribute('radio-name');
      } else {
        this.selectedOption.innerText = this.querySelector('input:checked').value;
      }
      const radios = this.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        radio.setAttribute('aria-selected', radio.checked ? 'true' : 'false');
      });
      // console.log(event.detail);
      // this.summary.click();
      if (this.details && this.details.open) {
        setTimeout(() => {
          this.details.open = false;
          if (this.summary) this.summary.focus();
        }, 0);
      }
    });

    // Focus trap for form-element dropdowns
    if (this.classList.contains('form-element')) {
      const details = this.querySelector('details');
      details.addEventListener('toggle', () => {
        if (details.open) {
          this.trapOptionsFocus();
        } else {
          this.removeOptionsFocusTrap();
        }
      });
    }
  }
  trapOptionsFocus() {
    const options = this.options;
    if (!options) return;

    // Remove any previous handler
    this.removeOptionsFocusTrap();

    this._optionsTrapHandler = e => {
      const radios = Array.from(options.querySelectorAll('input[type="radio"]:not([disabled])'));
      if (radios.length === 0) return;

      // Arrow key navigation
      const currentIndex = radios.indexOf(document.activeElement);
      if ((e.key === 'ArrowDown' || e.key === 'Down') && currentIndex !== -1) {
        e.preventDefault();
        const next = (currentIndex + 1) % radios.length;
        radios[next].focus();
        return;
      }
      if ((e.key === 'ArrowUp' || e.key === 'Up') && currentIndex !== -1) {
        e.preventDefault();
        const prev = (currentIndex - 1 + radios.length) % radios.length;
        radios[prev].focus();
        return;
      }

      // Enter/Space: select the focused radio, close dropdown, focus summary
      if ((e.key === 'Enter' || e.key === ' ') && radios.includes(document.activeElement)) {
        e.preventDefault();
        const radio = document.activeElement;
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Close dropdown and focus summary
        const details = this.options.closest('details');
        if (details) {
          details.open = false;
          if (this.summary) this.summary.focus();
        }
      }

      // Escape: close the dropdown and focus summary
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        const details = this.options.closest('details');
        if (details) {
          details.open = false;
          if (this.summary) this.summary.focus();
        }

        // Add click outside handler for closing details when open
        this._onClickOutside = e => {
          if (!this.details.open) return;
          // If click is inside the details/options, do nothing
          if (this.details.contains(e.target)) return;
          this.details.removeAttribute('open');
          this.summary.setAttribute('aria-expanded', false);
          this.summary.focus();
        };

        // Listen for details open/close to add/remove click outside handler
        this.details.addEventListener('toggle', () => {
          if (this.details.open) {
            document.addEventListener('mousedown', this._onClickOutside);
            document.addEventListener('touchstart', this._onClickOutside);
          } else {
            document.removeEventListener('mousedown', this._onClickOutside);
            document.removeEventListener('touchstart', this._onClickOutside);
          }
        });
      }
    };

    options.addEventListener('keydown', this._optionsTrapHandler);

    // Focus the checked radio or the first one
    const radios = Array.from(options.querySelectorAll('input[type="radio"]:not([disabled])'));
    const checked = radios.find(r => r.checked);
    (checked || radios[0])?.focus();
  }

  removeOptionsFocusTrap() {
    if (this._optionsTrapHandler) {
      document.removeEventListener('keydown', this._optionsTrapHandler);
      this._optionsTrapHandler = null;
    }
  }
}

customElements.define('gaia-select', GaiaSelect);

class GaiaMobileMenu extends GaiaDropdown {
  constructor() {
    super();
    // Add event listeners to all .menu-close elements within this menu
    this.querySelectorAll('.menu-close').forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        this.close();
      });
    });

    // --- Start mobile menu drilldown logic ---
    let mobileMenuCurrentLevel = '0';
    let mobileMenuCurrentParent = null;

    // Mobile menu tiers
    const setupMobileMenuDrilldown = () => {
      const menuRoot = document.getElementById('mobile-menu-drilldown');
      if (!menuRoot) return;
      if (window.innerWidth >= 1299) return;

      // Try to restore previous state (Accessibility)
      let selector = `.mobile-menu-view[data-level="${mobileMenuCurrentLevel}"]`;
      if (mobileMenuCurrentParent) selector += `[data-parent="${mobileMenuCurrentParent}"]`;
      let viewToShow = menuRoot.querySelector('.mobile-menu-view[data-level="0"]');

      // Add classes to set initial state
      menuRoot.querySelectorAll('.mobile-menu-view').forEach(view => {
        if (view.getAttribute('data-level') === '0') {
          view.style.transform = 'translateX(0)';
          view.classList.remove('inactive-menu');
          view.classList.add('active-menu');
        } else {
          view.style.transform = 'translateX(-100%)';
          view.classList.remove('active-menu');
          view.classList.add('inactive-menu');
        }
      });

      let currentView = viewToShow;

      // Trap focus in the active menu view on first open
      if (currentView) {
        const firstLink = currentView.querySelector('a, button');
        if (firstLink) {
          firstLink.focus();
        }
        // Focus trap within the new view
        trapFocus(currentView, firstLink || currentView);
      }

      // Update classes for all views
      function updateMenuViewClasses(activeView) {
        // Always keep first level (data-level=0) active-menu
        // Always keep activeView and its direct parent active-menu so they can stack
        const parentId = activeView.getAttribute('data-parent');
        let parentView = null;
        if (parentId) {
          parentView = menuRoot.querySelector(`.mobile-menu-view[data-index="${parentId}"]`);
        }
        menuRoot.querySelectorAll('.mobile-menu-view').forEach(view => {
          const isRoot = view.getAttribute('data-level') === '0';
          if (view === activeView || view === parentView || isRoot) {
            // Instantly remove inactive-menu, add active-menu
            view.classList.remove('inactive-menu');
            view.classList.add('active-menu');
            // If there was a pending timeout to add inactive-menu, clear it
            if (view._offCanvasTimeout) {
              clearTimeout(view._offCanvasTimeout);
              view._offCanvasTimeout = null;
            }
          } else {
            // Remove active-menu immediately, but delay adding inactive-menu for animation
            view.classList.remove('active-menu');
            if (view._offCanvasTimeout) {
              clearTimeout(view._offCanvasTimeout);
            }
            view._offCanvasTimeout = setTimeout(() => {
              view.classList.add('inactive-menu');
              view._offCanvasTimeout = null;
            }, 300);
          }
        });
      }

      menuRoot.addEventListener('click', function (e) {
        const nextBtn = e.target.closest('button.mobile-menu-next');
        const backBtn = e.target.closest('button.mobile-menu-back');

        if (nextBtn) {
          const index = nextBtn.getAttribute('data-index');
          // Parent stays, next slides in on top
          const nextView = menuRoot.querySelector(`.mobile-menu-view[data-parent="${index}"]`);
          if (nextView) {
            nextView.style.transform = 'translateX(0)';
            updateMenuViewClasses(nextView);
            // Don't hide parent, just let nextView cover it
            currentView = nextView;
            // Store state
            mobileMenuCurrentLevel = nextView.getAttribute('data-level');
            mobileMenuCurrentParent = nextView.getAttribute('data-parent');
            // Shift focus to first link in the new menu
            const firstLink = nextView.querySelector('a, button');
            if (firstLink) {
              firstLink.focus();
            }
            // Focus trap within the new view
            trapFocus(nextView, firstLink || nextView);
          }
        }
        if (backBtn) {
          const parentLevel = parseInt(currentView.getAttribute('data-level')) - 1;
          let parentView;
          if (parentLevel === 0) {
            parentView = menuRoot.querySelector('.mobile-menu-view[data-level="0"]');
          } else {
            const parentIndex = currentView.getAttribute('data-parent').split('-')[0];
            parentView = menuRoot.querySelector(
              `.mobile-menu-view[data-level="${parentLevel}"][data-parent="${parentIndex}"]`
            );
          }
          if (parentView) {
            // Animate current out to right, parent slides in from left
            if (
              currentView.getAttribute('data-level') === '2' ||
              currentView.getAttribute('data-level') === '1'
            ) {
              currentView.classList.add('animating-out');
              currentView.style.transform = 'translateX(-100%)';
              parentView.style.transform = 'translateX(0)';
              updateMenuViewClasses(parentView);

              // Wait for transition to finish before lowering zIndex
              const onTransitionEnd = ev => {
                if (ev.propertyName === 'transform') {
                  currentView.classList.remove('animating-out');
                  currentView.removeEventListener('transitionend', onTransitionEnd);
                }
              };
              currentView.addEventListener('transitionend', onTransitionEnd);
              currentView = parentView;
              // Store state
              mobileMenuCurrentLevel = parentView.getAttribute('data-level');
              mobileMenuCurrentParent = parentView.getAttribute('data-parent');

              // Focus onto the first link or button
              const firstLink = parentView.querySelector('a, button');
              if (firstLink) {
                firstLink.focus();
              }
              // Focus trap within the new view
              trapFocus(parentView, firstLink || parentView);
            } else {
              currentView.style.transform = 'translateX(-100%)';
              parentView.style.transform = 'translateX(0)';
              updateMenuViewClasses(parentView);
              currentView = parentView;
              mobileMenuCurrentLevel = parentView.getAttribute('data-level');
              mobileMenuCurrentParent = parentView.getAttribute('data-parent');
              // Focus onto the first link or button
              const firstLink = parentView.querySelector('a, button');
              if (firstLink) {
                firstLink.focus();
              }
              // Focus trap within the new view
              trapFocus(parentView, firstLink || parentView);
            }
          }
        }
      });
    };

    // Run on load and on resize
    window.addEventListener('DOMContentLoaded', setupMobileMenuDrilldown);
    window.addEventListener('resize', setupMobileMenuDrilldown);
    setupMobileMenuDrilldown();
    // --- End mobile menu drilldown logic ---
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector('details');
    if (detailsElement) {
      if (detailsElement.hasAttribute('open')) {
        detailsElement.setAttribute('aria-label', 'Close Main Menu');
      } else {
        detailsElement.setAttribute('aria-label', 'Open Main Menu');
      }
    }
  }

  close() {
    if (window.matchMedia('(min-width: 1300px)').matches) {
      return;
    }

    this.details.classList.remove('open');
    this.details.classList.remove('opening');
    this.details.classList.add('closing');
    if (!this.closest('details')) {
    }
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('menu-open');
    setTimeout(() => {}, 300);
    document.removeEventListener('click', this.clickOffListener);
    setTimeout(() => {}, 300); //Delay to allow attributes to be updated
  }

  close() {
    super.close();
    // Reset translateX on all menu levels to -100%, except level 0
    this.querySelectorAll('.mobile-menu-view').forEach(view => {
      if (view.getAttribute('data-level') !== '0') view.style.transform = 'translateX(-100%)';
    });
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
}

customElements.define('gaia-mobile-menu', GaiaMobileMenu);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
          this.hide();
      });
    } else {
      this.addEventListener('click', event => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', e => {
      e.preventDefault();
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach(link =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateSku();
      this.updateURL();
      this.updateBundleOptions();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateTechSpecs();
      this.updateRRP();
      this.updateInventoryAndDelivery();
      this.updateSaleBadge();
      this.updateFinanceDisplay(this.currentVariant.price);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), select => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSku() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.sku) return;
    const currentSkus = document.querySelectorAll(`.current__sku`);
    if (currentSkus.length > 0) {
      currentSkus.forEach(currentSku => {
        currentSku.innerHTML = 'SKU: ' + `${this.currentVariant.sku}`;
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach(mediaGallery =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateBundleOptions() {
    if (!this.currentVariant) return;

    const bundles = document.querySelectorAll('.simple-bundles');
    bundles.forEach(bundle => {
      if (bundle.dataset.variant == this.currentVariant.id) {
        bundle.classList.add('active');
      } else {
        bundle.classList.remove('active');
      }

      const hiddenInputs = bundle.querySelectorAll('input[type="hidden"]');
      hiddenInputs.forEach(hiddenInput => {
        if (bundle.dataset.variant == this.currentVariant.id) {
          hiddenInput.removeAttribute('disabled');
        } else {
          hiddenInput.setAttribute('disabled', true);
        }
      });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateFinanceDisplay(variantPrice) {
    const financeContainer = document.querySelector('.finance.fs-body-base');
    if (!financeContainer) return;

    // Only show finance if price >= 30000
    if (variantPrice >= 30000) {
      const instalments = Math.round(variantPrice / 3);
      // Format price
      const formattedInstalment = (instalments / 100).toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      financeContainer.querySelector('p span.fs-bold').textContent = formattedInstalment;
      financeContainer.style.display = '';
    } else {
      financeContainer.style.display = 'none';
    }
  }

  updateTechSpecs() {
    const techSpecs = document.querySelectorAll('.variant-tech-spec');
    if (!techSpecs) return;

    techSpecs.forEach(techSpec => {
      techSpec.classList.remove('active');
      if (techSpec.dataset.variantId == this.currentVariant.id) {
        techSpec.classList.add('active');
      }
    });
  }

  updateBackorderMessaging() {
    let backOrderMsg = document.querySelector('.product-inventory.active');
    // console.log("backOrderMsg", backOrderMsg);
    let backOrderProperty = document.querySelector('[data-backorder-property]');
    if (backOrderMsg && backOrderMsg.classList.contains('product-inventory--backorder')) {
      backOrderProperty.value = backOrderMsg.textContent.trim();
    } else {
      backOrderProperty.value = '';
      // console.log("backOrderProperty.value", backOrderProperty.value);
    }
  }

  updateRRP() {
    const rrps = document.querySelectorAll('.variant-rrp');
    if (!rrps) return;

    rrps.forEach(rrp => {
      rrp.classList.remove('active');
      if (parseInt(rrp.dataset.variantId) === parseInt(this.currentVariant.id)) {
        rrp.classList.add('active');
      }
    });
  }

  updateInventoryAndDelivery() {
    const inventories = document.querySelectorAll('.product-inventory');
    if (!inventories) return;

    inventories.forEach(inventory => {
      inventory.classList.remove('active');
      if (parseInt(inventory.dataset.variantId) === parseInt(this.currentVariant.id)) {
        inventory.classList.add('active');
        this.updateBackorderMessaging();
      }
    });

    const deliveries = document.querySelectorAll('.block--delivery__info');
    if (!deliveries) return;

    deliveries.forEach(delivery => {
      delivery.classList.remove('active');
      if (parseInt(delivery.dataset.variantId) === parseInt(this.currentVariant.id)) {
        delivery.classList.add('active');
      }
    });
  }

  updateSaleBadge() {
    const badges = document.querySelectorAll('.price__badge-custom');
    if (!badges) return;

    badges.forEach(badge => {
      badge.classList.remove('active');
      if (parseInt(badge.dataset.variantId === this.currentVariant.id)) {
        badge.classList.add('active');
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        // let backOrderMsg = html.querySelector(".product-inventory");
        // let backOrderProperty = document.querySelector(
        //   "[data-backorder-property]"
        // );
        // if (
        //   backOrderMsg &&
        //   backOrderMsg.classList.contains("product-inventory--backorder")
        // ) {
        //   backOrderProperty.value = backOrderMsg.textContent.trim();
        // } else {
        //   backOrderProperty.value = "";
        // }

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        const saleBadge = document.querySelector('.price__badge-sale');
        if (saleBadge) {
          if (this.currentVariant.compare_at_price > this.currentVariant.price) {
            saleBadge.classList.remove('hidden');
          } else {
            saleBadge.classList.add('hidden');
          }
        }

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      addButton.style.display = 'none';
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      addButton.style.display = '';
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.style.display = 'none';
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector('slideshow-component') &&
          this.classList.contains('complementary-products')
        ) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function getCookie(name) {
  var cookieArr = document.cookie.split(';');

  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split('=');

    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }

  return null;
}

// Helper to announce secondary image display for screen readers when hovered
document.addEventListener('DOMContentLoaded', function () {
  function handleAnnouncement(event, message) {
    // Find the closest image wrapper with .show-secondary
    const imageWrapper = event.target.closest('.show-secondary');
    if (imageWrapper) {
      const announcement = imageWrapper.querySelector('#image-announcement');
      if (announcement) {
        announcement.textContent = message;
      }
    }
  }

  // Use event delegation for mouseenter, mouseleave, focus, blur
  document.body.addEventListener(
    'mouseenter',
    function (event) {
      handleAnnouncement(event, 'Secondary image displayed');
    },
    true
  );

  document.body.addEventListener(
    'focus',
    function (event) {
      handleAnnouncement(event, 'Secondary image displayed');
    },
    true
  );

  document.body.addEventListener(
    'mouseleave',
    function (event) {
      handleAnnouncement(event, '');
    },
    true
  );

  document.body.addEventListener(
    'blur',
    function (event) {
      handleAnnouncement(event, '');
    },
    true
  );
});

// Mobile header search expand/collapse logic
// Adds/removes 'search-expanded' and 'search-closed' classes on the form for mobile toggling magic
document.addEventListener('DOMContentLoaded', function () {
  function isMobile() {
    return window.innerWidth <= 991;
  }

  var searchForms = document.querySelectorAll('.header__search form.search.search-modal__form');
  searchForms.forEach(function (form) {
    var input = form.querySelector('.search__input');
    var button = form.querySelector('.search__button');
    var closeBtn = form.querySelector('.search__close');
    var predictiveEnabled = button && button.dataset.predictiveSearchEnabled === 'true';
    var blockNextSubmitUntil = 0;
    var lastWidth = -1; // -1 ensures the initial setInitialState() call always runs

    if (!input || !button) return;

    // Start closed on mobile
    function setInitialState() {
      var currentWidth = window.innerWidth;
      // Virtual keyboard on mobile only changes height, not width — skip those resize events
      // to prevent the search from closing when the keyboard opens after input.focus()
      if (currentWidth === lastWidth) return;
      lastWidth = currentWidth;

      if (isMobile()) {
        form.classList.remove('search-expanded');
        form.classList.add('search-closed');
        input.style.display = 'none';
        if (closeBtn) {
          closeBtn.setAttribute('aria-hidden', 'false');
          closeBtn.removeAttribute('tabindex');
          closeBtn.style.display = 'block';
        }
      } else {
        form.classList.remove('search-closed', 'search-expanded');
        input.style.display = '';
        if (closeBtn) {
          closeBtn.setAttribute('aria-hidden', 'true');
          closeBtn.setAttribute('tabindex', '-1');
          closeBtn.style.display = 'none';
        }
      }
    }
    setInitialState();
    window.addEventListener('resize', setInitialState);

    // If predictive search is disabled, block immediate submit after icon tap on mobile.
    form.addEventListener(
      'submit',
      function (e) {
        if (!isMobile() || predictiveEnabled) return;
        if (Date.now() < blockNextSubmitUntil) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        }
      },
      true
    );

    // Toggle on button click (mobile only)
    button.addEventListener('click', function (e) {
      if (!isMobile()) return;

      if (!predictiveEnabled) {
        // Prevent native and third-party click handlers from forcing /search redirects.
        blockNextSubmitUntil = Date.now() + 1500;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        if (!form.classList.contains('search-expanded')) {
          form.classList.add('search-expanded');
          form.classList.remove('search-closed');
          input.style.display = '';
          input.focus();
        }
        return;
      }

      e.preventDefault();
      if (form.classList.contains('search-expanded')) {
        // form.classList.remove("search-expanded");
        // form.classList.add("search-closed");
        // input.style.display = "none";
      } else {
        form.classList.add('search-expanded');
        form.classList.remove('search-closed');
        input.style.display = '';
        input.focus();
      }
    });

    // Optional: hide input when focus is lost (mobile only)
    input.addEventListener('blur', function () {
      if (!isMobile()) return;
      setTimeout(function () {
        if (document.activeElement !== button && document.activeElement !== closeBtn) {
          form.classList.remove('search-expanded');
          form.classList.add('search-closed');
          input.style.display = 'none';
        }
      }, 100);
    });

    // Mobile: close button closes search
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        if (!isMobile()) return;
        e.preventDefault();
        form.classList.remove('search-expanded');
        form.classList.add('search-closed');
        input.style.display = 'none';
      });
    }
  });
});
